import { render, staticRenderFns } from "./XueTang.vue?vue&type=template&id=4185caea&scoped=true&"
import script from "./XueTang.vue?vue&type=script&lang=js&"
export * from "./XueTang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4185caea",
  null
  
)

export default component.exports